(function () {
  /* ============================================================
     TINY BEETS — CART PROGRESS BAR v5.1 (1 Oct 2026)
     Drop-in replacement for the whole shipping-bar script.
     Paste over Assets > shipping-bar.js. Nothing else changes.

     WHAT'S NEW IN v5: HOME DELIVERY MINIMUM (display only)
     A. Two-stage message. Below the zone minimum:
        "Add $X to unlock home delivery". At/above it:
        "$X to free delivery" ($175). Click & Collect selected:
        no minimum message at all.
     B. Zone-aware minimum, read (never written) from PickEasy:
        window.selectedSlotOption ('delivery' / 'pickup'),
        window.selectedLocationId + availableSetup.minOrderValue
        (PickEasy's own per-zone minimum), or the postcode typed
        in PickEasy's #delivery-location-zip box matched with
        PickEasy's own isZipcodeApplicable(). Last postcode + zone
        is remembered in localStorage 'tbfDeliveryZone' (30 days)
        so the product-page bar knows it too.
     C. Before any postcode is known: one generic line with both
        minimums. STATIC_100 / STATIC_65 below are a snapshot of
        PickEasy zones (30 Sep 2026), used only when PickEasy's
        data is not on the page (empty cart, postcode checker).
     D. Reacts to cart changes (unchanged plumbing) and to
        PickEasy postcode/method changes (a passive click/keyup
        listener plus a 1.5s read-only poll while a bar exists).
        Never touches PickEasy's widget, inputs or checkout rules.
     E. window.tbfDeliveryMinFor(postcode) for the postcode
        checker snippet. Kill switch: MIN_LIVE = false restores
        v4 behaviour exactly.

     WHAT'S NEW IN v4
     0. Third everyday tier: 🥣 Free food jar at $240
        (FREE_JAR_THRESHOLD, in cents). JAR_LIVE switch turns it
        off when the jars run out. The drawer bar now walks the
        same tier list as the product bar instead of hard-coding
        two tiers, so adding or removing a tier is one line.

     WHAT'S IN v3
     1. The everyday bar now uses the birthday bar's styling:
        warm cream card, plum/beet/gold palette, beet rider on the
        track, tier nodes that tick off. Three tiers:
        🚚 Free delivery $175 · 🥄 Free spoon $200 · 🥣 Free food jar $240.
     2. COMPACT MODE for the cart drawer, same palette. Mount:
          <div data-tbf-bar data-compact="true"></div>
        One line + slim track + Beet Points line. ~55px tall.
     3. GIFT_LIVE switch — when the spoons run out, set it to
        false and every bar drops the gift tier instantly.
     4. Drawer re-render survival (MutationObserver re-paints the
        bar when the theme redraws the drawer section).
     5. Birthday mode kept dormant for next year (its own timer).

     All styles are injected by this script. The old .tbf- CSS in
     the theme is no longer used — safe to delete whenever.

     Mount points:
       <div id="tbf-shipping-bar"></div>             full bar (product page)
       <div data-tbf-bar data-compact="true"></div>  compact bar (cart drawer)

     This script must load on EVERY page the drawer can open on —
     put it in theme.liquid (or a global custom-liquid section),
     not just the product template.
     ============================================================ */

  /* ---------- config ---------- */
  var GIFT_LIVE = true;        /* ← flip to false when the spoons run out */
  var JAR_LIVE = true;         /* ← flip to false when the food jars run out */
  var FREE_JAR_THRESHOLD = 24000;  /* cents. 24000 = $240. Use 25000 for $250. */
  var SHOW_POINTS = true;      /* Beet Points line in compact mode */
  var POINTS_PER_DOLLAR = 5;   /* base rate; VIPs earn double but we quote the floor */

  var BIRTHDAY_START = new Date('2026-08-03T08:00:00+10:00').getTime();
  var BIRTHDAY_END   = new Date('2026-08-06T23:59:59+10:00').getTime();

  var BEET_ICON = 'https://cdn.shopify.com/s/files/1/0422/1311/4009/files/tinybeets-party-beet-icon-01.png?v=1785062220';

  /* birthday tiers (dormant outside the window) */
  var TIERS = [
    { at: 7500,  icon: '🧁', label: 'Muffins',   short: '$75',  reward: 'delivery and your free birthday muffins' },
    { at: 17500, icon: '🚚', label: 'Shipping',  short: '$175', reward: 'free shipping' },
    { at: 20000, icon: '🍲', label: 'Free meal', short: '$200', reward: 'a free Tiny Beets meal' },
    { at: 25000, icon: '🥤', label: 'Thermos',   short: '$250', reward: 'the unreleased Tiny Beets thermos' }
  ];

  /* everyday tiers — gift and jar tiers drop out when their switch is false */
  function everydayTiers() {
    var t = [{ at: FREE_DELIVERY_THRESHOLD, icon: '🚚', label: 'Free delivery', short: '$175', reward: 'free delivery', brief: 'free delivery', done: 'Free delivery unlocked!' }];
    if (GIFT_LIVE) t.push({ at: FREE_GIFT_THRESHOLD, icon: '🥄', label: 'Free spoon', short: '$200', reward: 'a free Tiny Beets baby spoon', brief: 'a free spoon', done: 'Delivery + spoon unlocked!' });
    if (JAR_LIVE) t.push({ at: FREE_JAR_THRESHOLD, icon: '🥣', label: 'Free food jar', short: formatMoney(FREE_JAR_THRESHOLD), reward: 'a free insulated food jar', brief: 'a free food jar', done: 'Delivery, spoon + food jar unlocked!' });
    return t;
  }

  var FREE_DELIVERY_THRESHOLD = 17500;
  var FREE_GIFT_THRESHOLD = 20000;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  /* ---------- v5: home delivery minimum (display only) ---------- */
  var MIN_LIVE = true;          /* ← false = v4 behaviour, no minimum messages */
  var LOW_MIN = 7500;           /* cents. Most eastern zones (generic line only) */
  var HIGH_MIN = 10000;         /* cents. WA, TAS, NT, NQLD, regional (generic line only) */
  var ZONE_KEY = 'tbfDeliveryZone';
  var ZONE_TTL = 30 * 24 * 60 * 60 * 1000;

  /* Snapshot of PickEasy zones, 30 Sep 2026. Only used when PickEasy's live
     data is not on the page. Anything covered and not listed is $75.
     Uncovered 0xxx / 6xxx / 7xxx postcodes fall back to $100. */
  var STATIC_100 = '800,810,812,820,822,828-830,832,834-836,839,2640-2647,2655-2656,2658-2660,2700,2706-2707,2710,2712-2714,2716,2731-2732,2734,3294,3333-3334,3345,3350-3352,3355-3358,3360-3361,3363-3364,3370-3371,3373-3375,3377-3381,3384-3385,3387,3400-3401,3409,3435,3442,3444,3446-3448,3450-3451,3453,3460-3465,3467-3469,3472,3475,3478,3515-3517,3521-3523,3550-3551,3555-3559,3561-3568,3570-3573,3575,3579-3581,3583-3586,3588-3590,3607-3608,3610,3612,3614,3616-3618,3620-3624,3629-3631,3633-3641,3644,3646-3647,3649,3660,3662-3666,3669-3670,3672-3673,3675,3677-3678,3682-3683,3685,3687-3688,3690-3691,3694-3695,3697-3701,3714-3715,3717-3720,3722-3723,3725-3728,3730,3732,3735,3737-3741,3744,3746-3747,3749,4680,4695,4699-4703,4710-4712,4714-4718,4720,4737,4740-4741,4750-4751,4753-4754,4805-4818,4820,4849-4850,4852,4854-4855,4859-4861,4865,4868-4871,4873,4877-4880,4882-4885,5290-5291,5322,5330-5333,5340-5346,5417,5422,5431,5433,5453-5454,5472-5473,5480-5483,5485,5491,5493,5495,5521-5523,5540,5556,5576,5600,5608-5609,5611,5700,5710,6000,6003-6012,6014-6038,6041-6044,6050-6074,6076-6079,6081-6084,6090,6100-6112,6121-6123,6125,6147-6160,6162-6176,6180-6182,6207-6211,6214-6215,6218-6221,6223-6230,6232-6233,6236-6237,6239-6240,6251-6256,6258,6271,6280-6282,6284-6286,6288,6290,6302,6401,6403,6503,6507,6511,6514,6516,6518,6521,6525,6528,6530,6532,6556,6558,6562,6566,6907,7000-7002,7004-7012,7015-7027,7030,7050,7052-7055,7109,7112-7113,7119-7120,7140,7150,7155,7170-7173,7210-7212,7248-7250,7252-7254,7258,7267-7268,7270,7275-7277,7290-7292,7300-7307,7310,7315-7316,7320-7322,7325,7330-7331';
  var STATIC_65_UNUSED = '3233-3239,3241-3243,3249-3251,3254,3260,3264-3287,3289,3293,3300-3305,3322-3325,3329-3330';

  function cleanPostcode(v) {
    var s = String(v || '').replace(/\s+/g, '');
    return /^\d{3,4}$/.test(s) ? (s.length === 3 ? '0' + s : s) : null;
  }

  function inRanges(n, list) {
    var parts = list.split(',');
    for (var i = 0; i < parts.length; i++) {
      var ab = parts[i].split('-');
      var a = parseInt(ab[0], 10), b = ab.length > 1 ? parseInt(ab[1], 10) : a;
      if (n >= a && n <= b) return true;
    }
    return false;
  }

  function staticMinFor(pc) {
    var n = parseInt(pc, 10);
    if (inRanges(n, STATIC_100)) return HIGH_MIN;
    /* v5.1: South West VIC is $75 like the rest (Anthony, 1 Oct: the $65 in PickEasy is a typo) */
    var first = pc.charAt(0);
    if (first === '0' || first === '6' || first === '7') return HIGH_MIN;
    return LOW_MIN;
  }

  /* PickEasy's own per-zone minimum for a location id (read only) */
  function pickeasyMinForLocation(locId) {
    try {
      var list = window.availableSetup && window.availableSetup.minOrderValue;
      if (!locId || !list || !list.length) return null;
      for (var i = 0; i < list.length; i++) {
        var m = list[i];
        if (m.locationId === locId && m.fulfillmentType === 'delivery') {
          var v = Math.round(parseFloat(m.minOrderValue) * 100);
          return isNaN(v) ? null : v;
        }
      }
    } catch (e) {}
    return null;
  }

  /* First PickEasy delivery zone matching a postcode, same order PickEasy uses */
  function pickeasyLocationForPostcode(pc) {
    try {
      var locs = window.availableLocations;
      var fn = window.isZipcodeApplicable;
      if (!locs || !locs.length || typeof fn !== 'function') return null;
      for (var i = 0; i < locs.length; i++) {
        var l = locs[i];
        if (l.type === 'delivery' && fn(l.zipcodeMatchingType, pc, l.zipcodes, l.zipcodesToExclude)) return l;
      }
    } catch (e) {}
    return null;
  }

  function readZone() {
    try {
      var z = JSON.parse(localStorage.getItem(ZONE_KEY) || 'null');
      if (z && z.pc && z.min && Date.now() - (z.t || 0) < ZONE_TTL) return z;
    } catch (e) {}
    return null;
  }

  function saveZone(pc, min, src) {
    if (!pc || !min) return;
    try {
      var old = readZone();
      if (old && old.pc === pc && old.min === min && old.src === src) return;
      localStorage.setItem(ZONE_KEY, JSON.stringify({ pc: pc, min: min, src: src, t: Date.now() }));
    } catch (e) {}
  }

  /* Public helper for the postcode checker: { min: cents, src } or null */
  window.tbfDeliveryMinFor = function (value, remember) {
    var pc = cleanPostcode(value);
    if (!pc) return null;
    var loc = pickeasyLocationForPostcode(pc);
    var min = loc ? pickeasyMinForLocation(loc.id) : null;
    var out = min ? { min: min, src: 'pickeasy' } : { min: staticMinFor(pc), src: 'static' };
    if (remember) { saveZone(pc, out.min, out.src); setTimeout(checkDeliveryChange, 0); }
    return out;
  };

  function typedPostcode() {
    var els = document.querySelectorAll('#delivery-location-zip');
    for (var i = 0; i < els.length; i++) {
      var v = String(els[i].value || '').replace(/\s+/g, '');
      if (/^\d{4}$/.test(v)) return v;
    }
    return null;
  }

  /* { method: 'delivery' | 'pickup', min: cents | null, pc: string | null } */
  function deliveryState() {
    var opt = window.selectedSlotOption;
    if (!opt) {
      var ft = document.querySelectorAll('input[name="attributes[Order Fulfillment Type]"]');
      for (var i = 0; i < ft.length; i++) if (ft[i].value === 'Store Pickup') opt = 'pickup';
    }
    if (opt === 'pickup') return { method: 'pickup', min: null, pc: null };

    var pc = typedPostcode();
    var min = null;
    if (opt === 'delivery' && window.selectedLocationId) {
      min = pickeasyMinForLocation(window.selectedLocationId);
      if (min && pc) saveZone(pc, min, 'pickeasy');
    }
    if (!min && pc) {
      var loc = pickeasyLocationForPostcode(pc);
      if (loc) { min = pickeasyMinForLocation(loc.id); if (min) saveZone(pc, min, 'pickeasy'); }
    }
    if (!min) {
      var z = readZone();
      if (z && (!pc || z.pc === pc)) { min = z.min; pc = z.pc; }
    }
    return { method: 'delivery', min: min, pc: min ? pc : null };
  }

  /* Minimum-stage copy. Returns null when the normal tier copy should show. */
  function minStage(cartTotal, ds) {
    if (!MIN_LIVE || cartTotal <= 0) return null;
    var gap, where;
    if (ds.method === 'pickup') return { kind: 'pickup' };
    if (ds.min) {
      where = ds.pc ? ' for ' + ds.pc : ' for your area';
      if (cartTotal < ds.min) {
        gap = ds.min - cartTotal;
        return {
          kind: 'below', gap: gap, pct: (cartTotal / ds.min) * 100,
          note: 'Home delivery minimum' + where + ' is ' + formatMoney(ds.min) + '. Click &amp; Collect has no minimum.'
        };
      }
      return { kind: 'ok', note: 'Home delivery minimum' + where + ' is ' + formatMoney(ds.min) + '. You’re in.' };
    }
    /* no postcode yet: show both minimums */
    if (cartTotal < LOW_MIN) {
      return {
        kind: 'below-generic', gap: LOW_MIN - cartTotal, gapHigh: HIGH_MIN - cartTotal, pct: (cartTotal / LOW_MIN) * 100,
        note: 'Home delivery minimum is $75 in most eastern areas and $100 in WA, TAS, NT, North QLD and some regional areas. Click &amp; Collect has no minimum.'
      };
    }
    if (cartTotal < HIGH_MIN) {
      return {
        kind: 'mid-generic',
        note: 'WA, TAS, NT, North QLD and some regional areas need $100 for home delivery (add ' + formatMoney(HIGH_MIN - cartTotal) + '). Enter your postcode to check yours.'
      };
    }
    return null;
  }

  function birthdayMode(bar) {
    var forced = bar && bar.getAttribute('data-mode');
    if (forced === 'on') return true;
    if (forced === 'off') return false;
    var now = Date.now();
    return now >= BIRTHDAY_START && now <= BIRTHDAY_END;
  }

  /* ---------- shared card styles, injected once ---------- */
  function injectStyles() {
    if (document.getElementById('tbb-sb-styles')) return;
    var css =
      '.tbb-sb{--tbb-plum:#4A265A;--tbb-beet:#B4266B;--tbb-gold:#E3A83C;--tbb-green:#4C8B4F;' +
        'font-family:inherit;color:#3E3042;background:#FFF6E9;border:1px solid #EFDFC6;' +
        'border-radius:14px;padding:14px 16px 12px;box-sizing:border-box;}' +
      '.tbb-sb *{box-sizing:border-box;}' +
      '.tbb-sb__msg{font-size:14px;line-height:20px;margin:0 0 14px;text-align:center;color:#3E3042;}' +
      '.tbb-sb__msg strong{color:var(--tbb-plum);font-weight:700;}' +
      '.tbb-sb__amt{color:var(--tbb-beet);font-weight:700;white-space:nowrap;}' +
      '.tbb-sb__msg--win{color:var(--tbb-plum);font-weight:700;}' +
      '.tbb-sb__track{position:relative;height:10px;border-radius:99px;background:#EADDC6;margin:26px 0 10px;}' +
      '.tbb-sb__fill{position:absolute;left:0;top:0;bottom:0;border-radius:99px;' +
        'background:linear-gradient(90deg,#D8608F 0%,var(--tbb-beet) 60%,var(--tbb-gold) 100%);' +
        'transition:width .55s cubic-bezier(.4,1.3,.5,1);}' +
      '.tbb-sb__node{position:absolute;top:50%;width:10px;height:10px;margin:-5px 0 0 -5px;' +
        'border-radius:50%;background:#fff;border:2px solid #DCC9AA;transition:all .3s ease;}' +
      '.tbb-sb__node.is-done{background:var(--tbb-green);border-color:var(--tbb-green);}' +
      '.tbb-sb__rider{position:absolute;top:50%;width:34px;height:34px;margin:-17px 0 0 -17px;' +
        'transition:left .55s cubic-bezier(.4,1.3,.5,1);pointer-events:none;z-index:2;}' +
      '.tbb-sb__rider img{width:100%;height:100%;display:block;' +
        'filter:drop-shadow(0 2px 4px rgba(74,38,90,.28));}' +
      '.tbb-sb__rider.is-pop img{animation:tbbPop .6s ease;}' +
      '@keyframes tbbPop{0%{transform:scale(1) rotate(0)}35%{transform:scale(1.28) rotate(-9deg)}' +
        '70%{transform:scale(.95) rotate(5deg)}100%{transform:scale(1) rotate(0)}}' +
      '.tbb-sb__tiers{position:relative;height:48px;margin-top:2px;}' +
      '.tbb-sb__tier{position:absolute;top:0;text-align:center;white-space:nowrap;' +
        'opacity:.42;transition:opacity .3s ease;}' +
      '.tbb-sb__tier--mid{transform:translateX(-50%);}' +
      '.tbb-sb__tier--end{right:0;text-align:right;}' +
      '.tbb-sb__tier--start{left:0;text-align:left;}' +
      '.tbb-sb__tier.is-done{opacity:1;}' +
      '.tbb-sb__tier-ico{font-size:14px;line-height:16px;display:block;}' +
      '.tbb-sb__tier-lbl{display:block;font-size:10px;line-height:13px;font-weight:700;' +
        'letter-spacing:.02em;color:var(--tbb-plum);margin-top:1px;}' +
      '.tbb-sb__tier-amt{display:block;font-size:10px;line-height:13px;color:#8A7A8E;}' +
      '.tbb-sb__tier.is-done .tbb-sb__tier-amt{color:var(--tbb-green);font-weight:700;}' +
      '.tbb-sb__note{margin:11px 0 0;padding-top:9px;border-top:1px dashed #E4D3B8;' +
        'font-size:10.5px;line-height:15px;color:#8A7A8E;text-align:center;}' +
      '.tbb-sb--win{background:#FFF9EC;border-color:var(--tbb-gold);' +
        'box-shadow:0 0 0 3px rgba(227,168,60,.16);}' +
      '@media (max-width:360px){.tbb-sb__tier-lbl,.tbb-sb__tier-amt{font-size:9px;}}' +
      '@media (prefers-reduced-motion:reduce){.tbb-sb__fill,.tbb-sb__rider{transition:none;}' +
        '.tbb-sb__rider.is-pop img{animation:none;}}';
    var s = document.createElement('style');
    s.id = 'tbb-sb-styles';
    s.textContent = css;
    document.head.appendChild(s);
  }

  /* ---------- compact styles (drawer), same palette ---------- */
  function injectCompactStyles() {
    if (document.getElementById('tbfc-sb-styles')) return;
    var css =
      '.tbfc{--tbb-plum:#4A265A;--tbb-beet:#B4266B;--tbb-gold:#E3A83C;' +
        'font-family:inherit;background:#FFF6E9;border:1px solid #EFDFC6;' +
        'border-radius:10px;padding:7px 11px 7px;margin:6px 0 8px;box-sizing:border-box;}' +
      '.tbfc *{box-sizing:border-box;}' +
      '.tbfc--done{background:#FFF9EC;border-color:var(--tbb-gold);' +
        'box-shadow:0 0 0 2px rgba(227,168,60,.14);}' +
      '.tbfc__row{display:flex;justify-content:space-between;align-items:baseline;' +
        'gap:10px;margin:0 0 5px;flex-wrap:wrap;}' +
      '.tbfc__msg{font-size:12.5px;line-height:16px;margin:0;color:#3E3042;font-weight:500;flex:1;min-width:0;}' +
      '.tbfc__msg strong{color:var(--tbb-plum);font-weight:700;}' +
      '.tbfc__amt{color:var(--tbb-beet);font-weight:700;white-space:nowrap;}' +
      '.tbfc__track{background:#EADDC6;border-radius:99px;height:6px;overflow:hidden;}' +
      '.tbfc__fill{height:100%;border-radius:99px;' +
        'background:linear-gradient(90deg,#D8608F 0%,var(--tbb-beet) 60%,var(--tbb-gold) 100%);' +
        'transition:width .55s cubic-bezier(.34,1.56,.64,1);}' +
      '.tbfc__points{font-size:10.5px;line-height:14px;color:#8A7A8E;margin:0;white-space:nowrap;}' +
      '.tbfc__points b{color:var(--tbb-plum);}' +
      '.tbfc__note{font-size:10.5px;line-height:14px;color:#8A7A8E;margin:5px 0 0;}' +
      '@media (prefers-reduced-motion:reduce){.tbfc__fill{transition:none;}}';
    var s = document.createElement('style');
    s.id = 'tbfc-sb-styles';
    s.textContent = css;
    document.head.appendChild(s);
  }

  /* ---------- progress maths: equal slice per tier ---------- */
  function progressPercent(cartTotal, tiers) {
    var n = tiers.length, prev = 0;
    for (var i = 0; i < n; i++) {
      var top = tiers[i].at;
      if (cartTotal < top) {
        var within = (cartTotal - prev) / (top - prev);
        return ((i + within) / n) * 100;
      }
      prev = top;
    }
    return 100;
  }

  function nextTier(cartTotal, tiers) {
    for (var i = 0; i < tiers.length; i++) {
      if (cartTotal < tiers[i].at) return tiers[i];
    }
    return null;
  }

  /* ---------- shared tier-bar renderer (birthday + everyday) ---------- */
  function renderTierBar(bar, cartTotal, tiers, winMsg, note, msgOverride) {
    injectStyles();

    var pct = progressPercent(cartTotal, tiers);
    var next = nextTier(cartTotal, tiers);
    var msg;

    if (msgOverride) {
      msg = msgOverride;
    } else if (!next) {
      msg = '<span class="tbb-sb__msg--win">' + winMsg + '</span>';
    } else if (cartTotal === 0) {
      msg = 'Add <span class="tbb-sb__amt">' + formatMoney(next.at) + '</span> to unlock ' + next.reward + '.';
    } else if (MIN_LIVE && next.at === FREE_DELIVERY_THRESHOLD) {
      msg = '<span class="tbb-sb__amt">' + formatMoney(next.at - cartTotal) + '</span> to <strong>free delivery</strong>.';
    } else {
      msg = 'You’re <span class="tbb-sb__amt">' + formatMoney(next.at - cartTotal) +
            '</span> away from <strong>' + next.reward + '</strong>.';
    }

    var nodes = '', tierCells = '';
    for (var i = 0; i < tiers.length; i++) {
      var t = tiers[i];
      var done = cartTotal >= t.at;
      var at = ((i + 1) / tiers.length) * 100;
      nodes += '<span class="tbb-sb__node' + (done ? ' is-done' : '') + '" style="left:' + at + '%;"></span>';
      /* anchor each label under its dot: centred normally, edge-pinned near the ends */
      var posClass, posStyle;
      if (at > 88) { posClass = 'tbb-sb__tier--end'; posStyle = ''; }
      else if (at < 12) { posClass = 'tbb-sb__tier--start'; posStyle = ''; }
      else { posClass = 'tbb-sb__tier--mid'; posStyle = 'left:' + at + '%;'; }
      tierCells += '<div class="tbb-sb__tier ' + posClass + (done ? ' is-done' : '') + '"' +
                 (posStyle ? ' style="' + posStyle + '"' : '') + '>' +
                 '<span class="tbb-sb__tier-ico">' + (done ? '✅' : t.icon) + '</span>' +
                 '<span class="tbb-sb__tier-lbl">' + t.label + '</span>' +
                 '<span class="tbb-sb__tier-amt">' + t.short + '</span>' +
               '</div>';
    }

    var riderPct = Math.max(2.5, Math.min(pct, 97.5));

    var prevPct = parseFloat(bar.getAttribute('data-pct') || '-1');
    var pop = prevPct >= 0 && Math.floor(prevPct / 25) < Math.floor(pct / 25);
    bar.setAttribute('data-pct', pct);

    bar.innerHTML =
      '<div class="tbb-sb' + (next ? '' : ' tbb-sb--win') + '">' +
        '<p class="tbb-sb__msg">' + msg + '</p>' +
        '<div class="tbb-sb__track">' +
          '<div class="tbb-sb__fill" style="width:' + pct + '%;"></div>' +
          nodes +
          '<div class="tbb-sb__rider' + (pop ? ' is-pop' : '') + '" style="left:' + riderPct + '%;">' +
            '<img src="' + BEET_ICON + '" alt="" width="34" height="34" />' +
          '</div>' +
        '</div>' +
        '<div class="tbb-sb__tiers">' + tierCells + '</div>' +
        (note ? '<div class="tbb-sb__note">' + note + '</div>' : '') +
      '</div>';
  }

  /* ---------- birthday bar (dormant outside the window) ---------- */
  function renderBirthday(bar, cartTotal) {
    renderTierBar(bar, cartTotal, TIERS,
      'That is the lot. Muffins, free shipping, a free meal and the thermos are all yours.',
      'Birthday code applies at checkout. Delivery from $75 (Eastern States) and $100 (WA, TAS, NT &amp; Regional). Free items added automatically while stocks last.');
  }

  /* ---------- everyday bar — now birthday-styled ---------- */
  function renderEveryday(bar, cartTotal) {
    var winMsg;
    if (GIFT_LIVE && JAR_LIVE) winMsg = '🎉 Free delivery, a baby spoon and the food jar. All yours.';
    else if (GIFT_LIVE || JAR_LIVE) winMsg = '🎉 Free delivery and your free gift. Both yours.';
    else winMsg = '🎉 Free delivery unlocked.';
    var note = 'Delivery available on orders over $75 (Eastern States) · $100 (WA, TAS, NT &amp; Regional).' +
      ((GIFT_LIVE || JAR_LIVE) ? ' Free items added automatically while stocks last.' : '');
    var msgOverride = null;
    var stage = minStage(cartTotal, deliveryState());
    if (stage) {
      var gifts = (GIFT_LIVE || JAR_LIVE) ? ' Free items added automatically while stocks last.' : '';
      if (stage.kind === 'pickup') {
        note = 'Click &amp; Collect selected: no minimum spend.' + gifts;
        var giftNext = nextTier(cartTotal, everydayTiers().slice(1));
        msgOverride = '<strong>Click &amp; Collect</strong> has no minimum spend.' + (giftNext
          ? ' You’re <span class="tbb-sb__amt">' + formatMoney(giftNext.at - cartTotal) + '</span> away from <strong>' + giftNext.reward + '</strong>.'
          : '');
      } else {
        note = stage.note + gifts;
      }
      if (stage.kind === 'below') {
        msgOverride = 'Add <span class="tbb-sb__amt">' + formatMoney(stage.gap) + '</span> to unlock <strong>home delivery</strong>.';
      } else if (stage.kind === 'below-generic') {
        msgOverride = 'Add <span class="tbb-sb__amt">' + formatMoney(stage.gap) + '</span> to unlock <strong>home delivery</strong> ' +
          '(<span class="tbb-sb__amt">' + formatMoney(stage.gapHigh) + '</span> in $100 areas).';
      }
    }
    renderTierBar(bar, cartTotal, everydayTiers(), winMsg, note, msgOverride);
  }

  /* ---------- compact bar (cart drawer) ---------- */
  function renderCompact(bar, cartTotal) {
    injectCompactStyles();

    var tiers = everydayTiers();
    var next = nextTier(cartTotal, tiers);
    var msg, pct, done = false, noteLine = '';
    var stage = minStage(cartTotal, deliveryState());

    if (stage && stage.kind === 'pickup') {
      var giftNext = nextTier(cartTotal, tiers.slice(1));
      msg = '🛍️ <strong>Click &amp; Collect</strong>: no minimum' + (giftNext
        ? ' · <span class="tbfc__amt">' + formatMoney(giftNext.at - cartTotal) + '</span> to ' + giftNext.brief
        : '');
      pct = giftNext ? Math.min((cartTotal / giftNext.at) * 100, 100) : 100;
    } else if (stage && (stage.kind === 'below' || stage.kind === 'below-generic')) {
      msg = '🚚 Add <span class="tbfc__amt">' + formatMoney(stage.gap) + '</span> to unlock <strong>home delivery</strong>';
      pct = Math.min(stage.pct, 100);
      noteLine = stage.kind === 'below-generic'
        ? '$75 minimum in most eastern areas. $100 in WA, TAS, NT, North QLD and some regional areas (add ' + formatMoney(stage.gapHigh) + '). Click &amp; Collect: no minimum.'
        : stage.note;
    } else if (!next) {
      pct = 100;
      done = true;
      var last = tiers[tiers.length - 1];
      msg = '🎉 <strong>' + last.done + '</strong>';
    } else {
      pct = Math.min((cartTotal / next.at) * 100, 100);
      var idx = tiers.indexOf(next);
      var gap = '<span class="tbfc__amt">' + formatMoney(next.at - cartTotal) + '</span>';
      if (idx === 0) {
        msg = cartTotal === 0
          ? next.icon + ' Free delivery on orders over <span class="tbfc__amt">' + formatMoney(next.at) + '</span>'
          : (MIN_LIVE
            ? next.icon + ' ' + gap + ' to <strong>' + next.brief + '</strong>'
            : next.icon + ' ' + gap + ' away from <strong>' + next.brief + '</strong>');
      } else {
        msg = '✅ <strong>' + tiers[idx - 1].done + '</strong> ' + next.icon + ' ' + gap + ' to ' + next.brief;
      }
    }

    if (stage && stage.kind === 'mid-generic') noteLine = stage.note;

    var pointsSpan = '';
    if (SHOW_POINTS && cartTotal > 0) {
      var pts = Math.round(cartTotal / 100) * POINTS_PER_DOLLAR;
      pointsSpan = '<span class="tbfc__points">earns <b>' + pts.toLocaleString() + ' Beet Points</b> 🌱</span>';
    }

    bar.innerHTML =
      '<div class="tbfc' + (done ? ' tbfc--done' : '') + '">' +
        '<div class="tbfc__row"><p class="tbfc__msg">' + msg + '</p>' + pointsSpan + '</div>' +
        '<div class="tbfc__track"><div class="tbfc__fill" style="width:' + pct + '%;"></div></div>' +
        (noteLine ? '<p class="tbfc__note">' + noteLine + '</p>' : '') +
      '</div>';
  }

  /* ---------- dispatch ---------- */
  var lastTotal = 0;

  var lastSig = '';

  function stateSig() {
    if (!MIN_LIVE) return '';
    var d = deliveryState();
    return d.method + '|' + (d.min || '') + '|' + (d.pc || '');
  }

  /* re-paint only when PickEasy's method / zone actually changed */
  function checkDeliveryChange() {
    var sig = stateSig();
    if (sig === lastSig) return;
    lastSig = sig;
    if (cartKnown) updateShippingBar(lastTotal);
  }

  var cartKnown = false;

  function updateShippingBar(cartTotal) {
    lastTotal = cartTotal;
    lastSig = stateSig();
    var bars = document.querySelectorAll('#tbf-shipping-bar, [data-tbf-bar]');
    if (!bars.length) return;
    bars.forEach(function (bar) {
      if (bar.getAttribute('data-compact') === 'true') {
        renderCompact(bar, cartTotal);
      } else if (birthdayMode(bar)) {
        renderBirthday(bar, cartTotal);
      } else {
        renderEveryday(bar, cartTotal);
      }
    });
  }

  /* ---------- cart plumbing (unchanged) ---------- */
  function fetchCartAndUpdate() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { cartKnown = true; updateShippingBar(cart.total_price); })
      .catch(function () { updateShippingBar(0); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchCartAndUpdate);
  } else {
    fetchCartAndUpdate();
  }
  document.addEventListener('cart:updated', fetchCartAndUpdate);
  document.addEventListener('cart:refresh', fetchCartAndUpdate);

  var _fetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var result = _fetch.apply(this, args);
    var url = typeof args[0] === 'string' ? args[0] : '';
    if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {
      result.then(function () { setTimeout(fetchCartAndUpdate, 500); });
    }
    return result;
  };

  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change'))) {
      this.addEventListener('load', function () { setTimeout(fetchCartAndUpdate, 500); });
    }
    return _open.apply(this, arguments);
  };

  /* ---------- drawer re-render survival ---------- */
  var observerTimer = null;
  var observer = new MutationObserver(function () {
    if (observerTimer) return;
    observerTimer = setTimeout(function () {
      observerTimer = null;
      var bars = document.querySelectorAll('#tbf-shipping-bar, [data-tbf-bar]');
      var needsRender = false;
      bars.forEach(function (bar) { if (!bar.firstChild) needsRender = true; });
      if (needsRender) {
        /* only instant-paint if we already know a real total —
           painting from 0 flashed the empty-cart message */
        if (lastTotal > 0) updateShippingBar(lastTotal);
        fetchCartAndUpdate(); /* true numbers */
      }
    }, 150);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  /* ---------- v5: follow PickEasy method / postcode changes (read only) ---------- */
  if (MIN_LIVE) {
    var nudge = function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('#order-slots, #tb-pc')) {
        setTimeout(checkDeliveryChange, 400);
        setTimeout(checkDeliveryChange, 1500);
      }
    };
    document.addEventListener('click', nudge, { capture: true, passive: true });
    document.addEventListener('keyup', nudge, { capture: true, passive: true });
    setInterval(function () {
      if (document.hidden) return;
      if (!document.querySelector('#tbf-shipping-bar, [data-tbf-bar]')) return;
      checkDeliveryChange();
    }, 1500);
  }

  window.tbbRefreshShippingBar = fetchCartAndUpdate;
})();